<template>

	<div class="container main-content">

		<transition name="rate-hold-timer-anim" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
		<div v-show="!consented">
			<div class="row mb-4 mt-5 pb-2">
				<div class="col-12 col-md-6 mt-lg-5 offset-md-3 text-center">
					<p>You have been asked to provide additional verification.<br />Only official <strong>Government issued</strong> documents may be used in the verification process.</p>
				</div>
			</div>
			<div class="row mb-4 mt-2 pb-2">
				<div class="col-12 col-md-6 offset-md-3 text-center">
					<p><small>By continuing, you agree and consent to the <a target="_blank" v-bind:href="tosURL">Terms of Service</a> and <a target="_blank" v-bind:href="ppURL">Privacy Policy</a></small></p>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-center">
					<a href="#" id="price-quote-next" class="btn next-btn" ref="btnNext" v-on:click.prevent="confirm()">NEXT</a>
				</div>
			</div>
		</div>
		</transition>

		<template v-if="consentFadeComplete">

			<transition name="rate-hold-timer-anim" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
			<div v-show="!flowFinished" class="row">
				<div class="col-12 text-center" style="outline:none" tabindex="-1" role="group">
					
					<iframe
						class="idenfy-frame"
						allow="accelerometer; autoplay; camera; gyroscope; payment"
						frameborder="0"
						height="100%"
						:src="iframeUrl"
						width="100%"
					>
					<p>Your browser does not support iframes.</p>
					</iframe>
				</div>
			</div>
			</transition>
			
			<transition name="rate-hold-timer-anim" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
			<div v-show="flowFinished" class="row" style="padding-top: 10vh">
				<div v-show="isSuccess" class="col-12 header-container text-center pb-3">
					<div class="checkmark" alt="Checkmark"></div>
				</div>
				
				<div class="col-12 header-container text-center pb-2">
					<h2 v-if="isSuccess" class="lrg primary-highlight">{{ headerMsg }}</h2>
					<h2 v-else class="lrg">{{ headerMsg }}</h2>
				</div>

				<div class="col-12 col-lg-6 offset-lg-3 text-center">
					<img class="full-width shadow-bottom" src="./../assets/img/shadow_bottom.png" alt="shadow">
				</div>
				<div class="col-12 col-lg-6 offset-lg-3 pt-4 text-center">
					<p v-html="bodyMsg"></p>
				</div>
			</div>
			</transition>

		</template>

		
	</div>

</template>

<script>

export default {
	data() {
		return {
			consented: false,
			flowFinished: false,
			consentFadeComplete: false,
			token: undefined,
			isSuccess: false,
			headerMsg: '',
			bodyMsg: ''
		}
	},
	created() {
		window.addEventListener("message", this.receiveMessage, false);

		this.token = this.$route.params.token;
		if(this.token == null){
			this.$gstate.redirectHome('', 100, 'Token not found.');
			return 
		}

	},
	destroyed(){
		window.removeEventListener("message", this.receiveMessage, false);
	},
	computed:{
		iframeUrl(){
			var url =  "https://ui.idenfy.com/?authToken=" + this.token
			this.$gstate.log(url);
			return url;
		},
		tosURL: function() {

			var urlstr = this.$gstate.getSiteURL() + '/terms-of-service';
			if(!this.$gstate.isCoincurve()){
				urlstr = "/#/terms-of-service";
			}

			return urlstr;
			
		},
		ppURL: function() {
			
			var urlstr = this.$gstate.getSiteURL() + '/privacy-policy';
			if(!this.$gstate.isCoincurve()){
				urlstr = "/#/privacy-policy";
			}

			return urlstr;
		}
	},
	methods: {
		receiveMessage(event) {

			// show approve state
			if(event.data.manualStatus == 'approved'){
				this.flowFinished = true;
				setTimeout(() => {
					this.isSuccess = true;
					this.headerMsg = "Thank you!"
					this.bodyMsg = "Your verification is complete.<br />We will contact you shortly to complete your order."
					
				}, 5000);
			}

			// show fail state
			if(event.data.manualStatus == 'failed'){
				this.flowFinished = true;
				setTimeout(() => {
					this.isSuccess = false;
					this.headerMsg = "Verification unsuccessful."
					this.bodyMsg = "Unfortunately your identify verification has failed.<br />Please contact us if you feel this is a mistake."
				}, 5000);
			}
		},
		confirm(){
			this.consented = true;
			setTimeout(() => {
				this.consentFadeComplete = true;
				
			}, 1000);
		}

	}
}
</script>
